import React from 'react';
import styled from 'styled-components/macro';
import { Button } from 'src/client/components/ui/Button';
import { Modal } from './Modal/Modal';

type Props = {
  className?: string;
  showModal: boolean;
  onToggleFavor: (enabled: boolean) => void;
  hideModal: () => void;
};

export const ModelSubscriptionModal = (props: Props) => {
  const { showModal, className = '', onToggleFavor, hideModal } = props;

  const handleHideModal = () => {
    onToggleFavor(false);
    hideModal();
  };

  return (
    <StyledModal
      show={showModal}
      onHide={handleHideModal}
      dialogClassName={`${className} subscription-modal`}
      modalBodyClassName="subscription-modal-body"
      className={className}
    >
      <SubscriptionTitle>Subscription</SubscriptionTitle>
      <SubscriptionDescription>
        Click OK to receive an email when this model has a new set scheduled. You can always unsubscribe from this email
        in the future by going to Favorites.
      </SubscriptionDescription>
      <Footer>
        <Button
          className="submit-button btn btn-primary"
          onClick={() => {
            onToggleFavor(true);
            hideModal();
          }}
        >
          Ok - Add Subscription
        </Button>
        <CloseButton className="btn close-button" onClick={handleHideModal}>
          Close
        </CloseButton>
      </Footer>
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  max-width: 365px;

  .man-modal-body {
    padding: 24px 0 24px 0;
  }
`;

const SubscriptionTitle = styled.span`
  font-size: 22px;
  display: block;
  margin-bottom: 10px;
  margin-top: 0;
  text-align: center;
  color: #000;
  letter-spacing: 0;
`;

const SubscriptionDescription = styled.span`
  color: #999ca1;
  display: block;
  margin: 12px 0 15px;
  font-size: 13px;
  letter-spacing: 0;
  text-align: center;
`;

const Footer = styled.div`
  margin-top: 15px;
  padding: 19px 20px 20px;
  text-align: right;
  border-top: 1px solid #e5e5e5;
  display: flex;
  justify-content: space-evenly;
`;

const CloseButton = styled(Button)`
  border: 1px solid #ccc;
  padding: 0 20px;
`;
